// extracted by mini-css-extract-plugin
export default {"table":"playersDataTable_table__yoLD7","onlyTable":"playersDataTable_onlyTable__EghTS","downloadPlayersToolbar":"playersDataTable_downloadPlayersToolbar__AFeEr"};